import CheckVehicleInfoModal from './check-vehicle-info-modal.vue'
export default CheckVehicleInfoModal
